import axios from 'axios'

export const GuardiansService = {
    loadGuardians: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/guardians')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    deleteGuardian: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/guardians/' + id)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    }
}



// WEBPACK FOOTER //
// ./src/services/guardians-service.js